import styled from 'styled-components'
import React from 'react'
import { tablet } from '../../common/assets/utils/_breakpoints'

interface ContainerProps {
  userIsLoggedin?: boolean
}

const PhoneLayout = (props: JSX.IntrinsicElements['div']) => {
  return <Container style={props.style}>{props.children}</Container>
}

const HEADER_HEIGHT = 56
const Container = styled.div`
  padding: 10px 24px 20px 24px;
  margin: auto;

  display: flex;
  flex-direction: column;

  text-align: left;
  height: calc(100% - ${HEADER_HEIGHT}px);

  @media (min-width: ${tablet}) {
    max-width:  ${tablet}px;
  }

  // For Desktop
  @media (min-width: 1024px) {
    max-width: 430px;
  }
`

export default PhoneLayout
